import Http from '@/services/http';
import { TransformerSummaryInfos } from 'sigma-mappings';

const urls = {
  getTransformerSummaryInfos: assetId => `ativo/${assetId}/resumo-dados/transformador`,
};

export default {
  getTransformerSummaryInfos(assetId) {
    const http = new Http();
    return http
      .get(urls.getTransformerSummaryInfos(assetId))
      .then(({ data }) => new TransformerSummaryInfos(data));
  },
};
